import moment from 'moment';
import { IRange } from '../../utils/types';

export const HEADER_HEIGHT = 30;
export const ROW_HEIGHT = 24;

export const getTablePeriodLabel = ({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): string => {
  const startDateObj = moment(startDate);
  const endDateObj = moment(endDate);
  const startYear = startDateObj.format('YYYY');
  const endYear = endDateObj.format('YYYY');
  if (startYear === endYear) {
    return startYear;
  }
  return `${startDateObj.format('YY')} - ${endDateObj.format('YY')}`;
};

export const getTableDateLabels = (
  currentPeriod: IRange,
  comparisonPeriod: IRange
): string[] => {
  return [
    getTablePeriodLabel(currentPeriod),
    getTablePeriodLabel(comparisonPeriod),
  ];
};
